<template>
  <div id="comprobantesAMEX">
    <v-card class="elevation-12">
      <v-toolbar dense dark color="blue-grey">
        <v-toolbar-title>Solicitudes de comprobación AMEX: {{ idsolicitud_amex }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-tooltip top>
          <v-btn slot="activator" :loading="loading" icon @click="newSol()">
            <v-icon>note_add</v-icon>
          </v-btn>
          <span>Nueva Comprobacion</span>
        </v-tooltip>
      </v-toolbar>
      <v-card-title>
        <v-spacer></v-spacer>
        <v-text-field v-model="search" append-icon="search" label="Buscar" single-line hide-details
          maxlength="200"></v-text-field>
      </v-card-title>
      <v-data-table :headers="headers" :items="solicitudes" :loading="loading" :search="search" class="elevation-1"
        rows-per-page-text="Registros por página" :pagination.sync="pagination" :items-per-page="10">
        <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
        <template slot="items" slot-scope="{ item }">
          <tr>
            <td class="text-xs-center">{{ item.idsolicitud_comprobacion_amex
            }}</td>
            <td class="text-xs-center">{{ item.tipo_solicitud }}</td>
            <td class="text-xs-center">{{ item.tipo_pago }}</td>
            <td class="text-xs-center">{{ formatCurrency(item.importe_total) }}</td>
            <td class="text-xs-center">{{ item.idcat_estatus.estatus }}</td>
            <td class="text-xs-center">{{ formatDateShort(item.fecha_creacion) }}</td>
            <td class="text-xs-center">
              <v-tooltip bottom>
                <v-btn slot="activator" small icon @click="showDetailSol(item.idsolicitud_comprobacion_amex)">
                  <v-icon>description</v-icon>
                </v-btn>
                <span>Ver Detalle</span>
              </v-tooltip>
            </td>
          </tr>
        </template>
        <template slot="no-data">
          <div class="text-xs-center">No hay comprobaciones registradas.</div>
        </template>
      </v-data-table>
    </v-card>
    <v-snackbar v-model="success" color="success" :timeout="2500" right>
      {{ msgSuccess }}
    </v-snackbar>
    <v-snackbar v-model="alert" color="error" :timeout="2500" bottom right>
      {{ msgError }}
    </v-snackbar>
    <v-dialog v-model="loading" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Procesando información
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogNewComprobacion" fullscreen hide-overlay :persistent="true"
      transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dense dark color="blue-grey">
          <v-btn icon dark :disabled="loading" @click="handleClose">
            <v-icon>close</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <v-toolbar-title>
            {{ detailSolCom ? 'Detalle de solicitud de comprobación AMEX' : 'Nueva solicitud de comprobación AMEX' }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark flat v-if="!detailSolCom" :loading="loading" @click="checkQuestionReq()">Guardar</v-btn>
            <v-btn dark flat v-if="detailSolCom && estatusSolicitud" :loading="loading"
              @click="checkSendComprobacion()">Enviar</v-btn>
            <v-tooltip v-if="detailSolCom && !estatusSolicitud" left>
              <v-btn slot="activator" :loading="loading" icon @click="print()">
                <v-icon>local_printshop</v-icon>
              </v-btn>
              <span>Imprimir</span>
            </v-tooltip>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm12 md6>
                <v-container>
                  <v-select v-model="solicitud.estado_cuenta" :error-messages="estadosCuentaErrors"
                    :disabled="detailSolCom" :items="estados_cuenta"
                    :item-text="item => `${item.tarjetahabiente} - ${item.periodo}`" item-value="idestado_cuenta_amex"
                    @input="$v.solicitud.estado_cuenta.$touch()" @blur="$v.solicitud.estado_cuenta.$touch()"
                    label="Estados de cuenta" />
                  <br />
                  <v-text-field v-model="solicitud.tipo_solicitud" label="Tipo de solicitud" disabled
                    box></v-text-field>
                  <v-flex xs12 sm12 md6>
                    <v-select v-model="solicitud.tipo_pago" :error-messages="tiposPagoErrors" :items="tipos_pago"
                      @input="$v.solicitud.tipo_pago.$touch()" @blur="$v.solicitud.tipo_pago.$touch()"
                      :disabled="detailSolCom" label="Tipo de Pago"></v-select>
                  </v-flex>
                  <div v-if="detailSolCom">
                    <h3 class="grey--text">FIRMAS</h3><br />
                    <v-list three-line dark>
                      <template v-for="(item, i) in firmas">
                        <v-list-tile class="pb-2 pt-2">
                          <v-list-tile-content>
                            <v-list-tile-title v-html="item.rol"></v-list-tile-title>
                            <v-list-tile-title v-html="item.nombre"></v-list-tile-title>
                            <v-list-tile-sub-title v-html="item.estado"></v-list-tile-sub-title>
                            <v-list-tile-sub-title v-show="item.estado !== 'En aprobación'"
                              v-html="item.fecha_actualizacion"></v-list-tile-sub-title>
                          </v-list-tile-content>
                        </v-list-tile>
                        <v-divider v-show="(i + 1) < firmas.length"></v-divider>
                      </template>
                    </v-list>
                  </div>
                </v-container>
              </v-flex>
              <v-flex xs12 sm12 md6>
                <v-container>
                  <h3 class="grey--text">Resumen del estado de cuenta seleccionado</h3>
                  <br />
                  <v-data-table :headers="headersEC" :items="estado_cuenta_seleccionado" :loading="loading"
                    :search="search" class="elevation-1" hide-actions>
                    <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
                    <template slot="items" slot-scope="{ item }">
                      <tr>
                        <td class="text-xs-center">{{ item.tarjetahabiente }}
                        </td>
                        <td class="text-xs-center">{{ formatDateShort(item.fecha_corte)
                          }}
                        </td>
                        <td class="text-xs-center">{{ formatDateShort(item.fecha_pago)
                          }}
                        </td>
                        <td class="text-xs-center">{{ formatCurrency(item.saldo_a_pagar) }}</td>
                      </tr>
                    </template>
                    <template slot="no-data">
                      <div class="text-xs-center">No se ha seleccionado estado de cuenta.</div>
                    </template>
                  </v-data-table>
                  <br />
                  <br />
                  <h3 class="grey--text">COMPROBANTES</h3><br />
                  <v-text-field v-model="solicitud.comprobantes.no_comprobantes" class="pt-3" label="No. Comprobantes"
                    box readonly></v-text-field>
                  <v-layout wrap>
                    <!-- Fila 1: AGREGAR / MOSTRAR -->
                    <v-flex xs12 sm6>
                      <v-btn small block color="blue-grey" class="white--text" @click="dialogNewCom = true"
                        :loading="loading" :style="!revisarAgregarBtn ? 'opacity: 0.5; pointer-events: none;' : ''">
                        Agregar
                        <v-icon small right dark>add_circle</v-icon>
                      </v-btn>
                    </v-flex>

                    <v-flex xs12 sm6>
                      <v-btn :disabled="solicitud.comprobantes.detalle.length == 0" small block :loading="loading"
                        color="blue-grey" class="white--text" @click="showDetailCom()">
                        Mostrar
                        <v-icon small right dark>remove_red_eye</v-icon>
                      </v-btn>
                    </v-flex>

                    <!-- Fila 2: DESCARGAR TODO (centrado) -->
                    <v-flex xs12 class="text-xs-center">
                      <v-btn small color="blue-grey" class="white--text" @click="descargarTodo" :loading="loading">
                        DESCARGAR TODO
                        <v-icon small right dark>cloud_download</v-icon>
                      </v-btn>
                    </v-flex>

                    <!-- Fila 3: SUBTOTAL / IVA -->
                    <v-flex xs12 sm6>
                      <v-text-field v-model="solicitud.comprobantes.subtotal" label="Subtotal" box prefix="$"
                        suffix="MXN" readonly></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm6>
                      <v-text-field v-model="solicitud.comprobantes.iva" label="IVA" box prefix="$" suffix="MXN"
                        readonly></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-text-field v-model="solicitud.comprobantes.importe_total" :error-messages="importeTotalErrors"
                    label="Importe por reembolsar" @input="$v.solicitud.comprobantes.importe_total.$touch()"
                    @blur="$v.solicitud.comprobantes.importe_total.$touch()" prefix="$" suffix="MXN" box
                    readonly></v-text-field>
                </v-container>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="confirmCloseReq" persistent max-width="400">
      <v-card>
        <v-card-title class="headline">¿Está seguro que desea salir?</v-card-title>
        <v-card-text>
          Va a cerrar esta ventana. Perderá los cambios capturados.
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" dark @click="confirmClose()">Salir</v-btn>
          <v-btn color="green" dark @click="confirmCloseReq = false">Mantenerse en solicitud</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="questionReq" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">¿Desea guardar la nueva solicitud?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click.native="questionReq = false">Cancelar</v-btn>
          <v-btn flat color="orange" @click.native="saveSol()">Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="questionSendComprobacion" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">¿Desea enviar la comprobacion?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click.native="questionSendComprobacion = false">Cancelar</v-btn>
          <v-btn flat color="orange" @click.native="sendSol()">Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogNewCom" :loading="loading" width="500" :persistent="true">
      <v-card>
        <v-toolbar dense dark color="blue-grey">
          <v-toolbar-title>Nuevo Comprobante</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-title>No. {{ solicitud.comprobantes.no_comprobantes + 1 }}</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-container>
            <v-radio-group v-model="solicitud.comprobantes.nueva.tipo_gasto" :error-messages="tipoGastoErrors"
              @change="resetCamposNuevoComprobante" :mandatory="false"
              @input="$v.solicitud.comprobantes.nueva.tipo_gasto.$touch()"
              @blur="$v.solicitud.comprobantes.nueva.tipo_gasto.$touch()">
              <div slot="label"><strong>Tipo de gasto</strong></div>
              <v-radio label="Deducible" color="primary" value="deducible"></v-radio>
              <v-radio label="No deducible" color="primary" value="no_deducible"></v-radio>
            </v-radio-group>
            <v-layout wrap>
              <v-flex xs12 sm12 md6>
                <v-btn block round :color="color.pdf" @click="$refs.pdf.click()">
                  PDF
                  <v-icon right dark>attach_file</v-icon>
                </v-btn>
                <input v-show="false" ref="pdf" type="file" @change="readFile('pdf')">
              </v-flex>

              <v-flex xs12 sm12 md6>
                <v-btn v-if="solicitud.comprobantes.nueva.tipo_gasto === 'deducible'" block round :color="color.xml"
                  @click="$refs.xml.click()">
                  XML
                  <v-icon right dark>attach_file</v-icon>
                </v-btn>
                <v-btn v-else block round :color="color.foto" @click="$refs.foto.click()">
                  FOTO
                  <v-icon right dark>attach_file</v-icon>
                </v-btn>
                <input v-show="false" ref="xml" type="file" @change="readFile('xml')">
                <input v-show="false" ref="foto" type="file" @change="readFile('foto')">
              </v-flex>
            </v-layout>
            <br />
            <v-select v-model="solicitud.comprobantes.nueva.concepto" :error-messages="conceptoErrors"
              :items="catalogos.conceptos" @input="$v.solicitud.comprobantes.nueva.concepto.$touch()"
              @blur="$v.solicitud.comprobantes.nueva.concepto.$touch()" item-text="descripcion" item-value="id"
              label="Concepto"></v-select>
            <v-select v-show="true" v-model="solicitud.comprobantes.nueva.detalleNoDeducible"
              :error-messages="detalleNoDeducibleErrors" :items="catalogos.detallesNoDeducibles"
              @input="$v.solicitud.comprobantes.nueva.detalleNoDeducible.$touch()"
              @blur="$v.solicitud.comprobantes.nueva.detalleNoDeducible.$touch()" item-text="descripcion"
              item-value="idcat_detalle_nodeducible" label="Detalle no deducible"></v-select>
            <v-text-field v-if="gastoDeducible" v-model="solicitud.comprobantes.nueva.rfc" :error-messages="rfcErrors"
              @input="$v.solicitud.comprobantes.nueva.rfc.$touch()" @blur="$v.solicitud.comprobantes.nueva.rfc.$touch()"
              label="RFC" :disabled="!gastoNoDeducible" :readonly="gastoDeducible"></v-text-field>
            <v-text-field v-if="gastoDeducible" v-model="solicitud.comprobantes.nueva.proveedor"
              :error-messages="proveedorErrors" @input="$v.solicitud.comprobantes.nueva.proveedor.$touch()"
              @blur="$v.solicitud.comprobantes.nueva.proveedor.$touch()" label="Proveedor" :disabled="!gastoNoDeducible"
              :readonly="gastoDeducible"></v-text-field>
            <v-text-field v-if="gastoDeducible" v-model="solicitud.comprobantes.nueva.folio"
              :error-messages="folioErrors" @input="$v.solicitud.comprobantes.nueva.folio.$touch()"
              @blur="$v.solicitud.comprobantes.nueva.folio.$touch()" label="Folio" :disabled="!gastoNoDeducible"
              :readonly="gastoDeducible"></v-text-field>
            <v-text-field v-if="gastoDeducible" v-model="solicitud.comprobantes.nueva.uuid" :error-messages="uuidErrors"
              @input="$v.solicitud.comprobantes.nueva.uuid.$touch()"
              @blur="$v.solicitud.comprobantes.nueva.uuid.$touch()" label="UUID" :disabled="!gastoNoDeducible"
              :readonly="gastoDeducible"></v-text-field>
            <v-text-field v-if="gastoDeducible" :value="formatMoney(solicitud.comprobantes.nueva.subtotal)"
              :error-messages="uuidErrors" @input="$v.solicitud.comprobantes.nueva.subtotal.$touch()"
              @blur="$v.solicitud.comprobantes.nueva.subtotal.$touch()" label="Subtotal" prefix="$" suffix="MXN"
              :disabled="!gastoNoDeducible" :readonly="gastoDeducible"></v-text-field>
            <v-text-field v-if="gastoDeducible" :disabled="!gastoNoDeducible" v-model="solicitud.comprobantes.nueva.iva"
              :error-messages="ivaErrors" @input="$v.solicitud.comprobantes.nueva.iva.$touch()"
              @blur="$v.solicitud.comprobantes.nueva.iva.$touch()" label="IVA" prefix="$" suffix="MXN"
              :readonly="gastoDeducible"></v-text-field>
            <v-text-field v-if="gastoDeducible && solicitud.comprobantes.nueva.totalIEPS" :disabled="!gastoNoDeducible"
              :value="formatMoney(solicitud.comprobantes.nueva.totalIEPS)" label="IEPS" prefix="$" suffix="MXN"
              :readonly="gastoDeducible"></v-text-field>
            <v-text-field v-if="gastoDeducible" :disabled="!gastoNoDeducible"
              v-model="solicitud.comprobantes.nueva.descuento" :error-messages="descuentoErrors"
              @input="$v.solicitud.comprobantes.nueva.descuento.$touch()"
              @blur="$v.solicitud.comprobantes.nueva.descuento.$touch()" label="Descuento" prefix="$" suffix="MXN"
              :readonly="gastoDeducible"></v-text-field>
            <v-text-field :disabled="!gastoNoDeducible" v-model="solicitud.comprobantes.nueva.total" label="Total"
              :error-messages="totalErrors" @input="$v.solicitud.comprobantes.nueva.total.$touch()"
              @blur="$v.solicitud.comprobantes.nueva.total.$touch()" prefix="$" suffix="MXN"
              :readonly="false"></v-text-field>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat v-show="!loading" color="blue-grey" @click.native="closeNewCom()">Cancelar</v-btn>
          <v-btn dark color="blue-grey" :loading="loading"
            @click.native="!comprobanteInvalidoPorTotales && saveNewCom()"
            :style="comprobanteInvalidoPorTotales ? 'opacity: 0.5; pointer-events: none;' : ''">
            Aceptar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogComprobantes" max-width="1200px">
      <v-card>
        <v-card-title class="headline justify-center">
          Comprobantes
        </v-card-title>
        <v-card-text>
          <v-data-table :headers="headersComprobantes" :items="solicitud.comprobantes.detalle" class="elevation-1"
            hide-default-footer>
            <template slot="items" slot-scope="{ item }">
              <tr>
                <td class="text-xs-center">{{ item.tipo_gasto }}</td>
                <td class="text-xs-center">{{ getConceptoDesc(item.concepto) }}</td>
                <td class="text-xs-center">{{ formatDateShort(item.fecha_timbrado) }}</td>
                <td class="text-xs-center">{{ formatCurrency(item.subtotal) }}</td>
                <td class="text-xs-center">{{ formatCurrency(item.iva) }}</td>
                <td class="text-xs-center">{{ formatCurrency(item.descuento) }}</td>
                <td class="text-xs-center">{{ formatCurrency(item.total) }}</td>
                <td class="text-xs-center">{{ item.uuid }}</td>
                <td class="text-xs-center">
                  <v-tooltip bottom v-if="item.data">
                    <v-btn slot="activator" small icon @click="verDetalleComprobante(item)">
                      <v-icon>visibility</v-icon>
                    </v-btn>
                    <span>Ver detalle</span>
                  </v-tooltip>

                  <v-tooltip bottom>
                    <v-btn slot="activator" small icon @click="descargarArchivo(item.pdf, 'pdf')">
                      <v-icon>picture_as_pdf</v-icon>
                    </v-btn>
                    <span>Descargar PDF</span>
                  </v-tooltip>

                  <v-tooltip bottom>
                    <v-btn slot="activator" small icon @click="descargarArchivo(item.foto, 'foto')">
                      <v-icon>image</v-icon>
                    </v-btn>
                    <span>Descargar Foto</span>
                  </v-tooltip>

                  <v-tooltip v-if="item.tipo_gasto == 'Deducible'" bottom>
                    <v-btn slot="activator" small icon @click="descargarArchivo(item.xml, 'xml')">
                      <v-icon>code</v-icon>
                    </v-btn>
                    <span>Descargar XML</span>
                  </v-tooltip>

                  <v-tooltip bottom v-if="detailSolCom">
                    <v-btn slot="activator" icon small @click="descargarArchivo(item.pdf, 'todo')">
                      <v-icon>archive</v-icon>
                    </v-btn>
                    <span>Descargar Todo</span>
                  </v-tooltip>

                  <v-tooltip bottom v-if="estatusSolicitud">
                    <v-btn slot="activator" small icon @click="eliminarComprobante(item)">
                      <v-icon>delete</v-icon>
                    </v-btn>
                    <span>Eliminar</span>
                  </v-tooltip>
                </td>

              </tr>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialogComprobantes = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="error" color="error" :timeout="2500" bottom right>
      {{ msgError }}
    </v-snackbar>

    <v-dialog v-model="dialogConfirmDelete" persistent max-width="400">
      <v-card>
        <v-card-title class="headline">¿Está seguro que desea eliminar el comprobante?</v-card-title>
        <v-card-text>
          Esta acción eliminará el comprobante de la solicitud y no podrá deshacerse.
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" dark @click="confirmarEliminacion()">Eliminar</v-btn>
          <v-btn color="green" dark @click="dialogConfirmDelete = false">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogDetCom" max-width="800px">
      <v-card>
        <v-card-title class="headline grey--text text--darken-2">
          Detalle del Comprobante
        </v-card-title>
        <v-card-text v-if="comprobanteSeleccionado">
          <v-container>
            <v-layout wrap>
              <v-flex xs12 sm6><strong>Tipo de Gasto:</strong> {{ comprobanteSeleccionado.tipo_gasto }}</v-flex>
              <v-flex xs12 sm6><strong>RFC:</strong> {{ comprobanteSeleccionado.rfc }}</v-flex>
              <v-flex xs12 sm6><strong>Beneficiario:</strong> {{ comprobanteSeleccionado.beneficiario }}</v-flex>
              <v-flex xs12 sm6><strong>Folio:</strong> {{ comprobanteSeleccionado.folio }}</v-flex>
              <v-flex xs12 sm6><strong>UUID:</strong> {{ comprobanteSeleccionado.uuid }}</v-flex>
              <v-flex xs12 sm6><strong>Fecha Timbrado:</strong> {{
                formatDateShort(comprobanteSeleccionado.fecha_timbrado)
                }}</v-flex>
              <v-flex xs12 sm6><strong>Subtotal:</strong> {{ formatCurrency(comprobanteSeleccionado.subtotal)
                }}</v-flex>
              <v-flex xs12 sm6><strong>IVA:</strong> {{ formatCurrency(comprobanteSeleccionado.iva) }}</v-flex>
              <v-flex xs12 sm6><strong>Descuento:</strong> {{ formatCurrency(comprobanteSeleccionado.descuento)
                }}</v-flex>
              <v-flex xs12 sm6><strong>Total:</strong> {{ formatCurrency(comprobanteSeleccionado.total) }}</v-flex>
              <v-flex xs12><strong>Concepto:</strong> {{ comprobanteSeleccionado.idcat_concepto.descripcion }} ({{
                comprobanteSeleccionado.idcat_concepto.subcuenta }})</v-flex>
              <v-flex xs12 sm6><strong>Cuenta:</strong> {{ comprobanteSeleccionado.idcat_concepto.cuenta }}</v-flex>
              <v-flex xs12 sm6><strong>Subcuenta:</strong> {{ comprobanteSeleccionado.idcat_concepto.subcuenta
                }}</v-flex>
              <v-flex xs12 sm6><strong>Fecha Creación:</strong> {{
                formatDateShort(comprobanteSeleccionado.fecha_creacion)
                }}</v-flex>
              <v-flex xs12 sm6><strong>Última Actualización:</strong> {{
                formatDateShort(comprobanteSeleccionado.fecha_actualizacion) }}</v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialogDetCom = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


  </div>
</template>
<script>
import services from "@/config/services";
import axios from "axios";
import { validationMixin } from "vuelidate";
import {
  decimal,
  maxLength,
  maxValue,
  minValue,
  requiredIf
} from "vuelidate/lib/validators";

export default {
  name: "SolicitudesAmex",
  mixins: [validationMixin],
  validations: {
    solicitud: {
      estado_cuenta: {
        required: requiredIf(function () {
          return true;
        })
      },
      tipo_pago: {
        required: requiredIf(function () {
          return true;
        })
      },
      comprobantes: {
        importe_total: {
          required: requiredIf(function () {
            return true;
          }),
          decimal,
          minValue: minValue(0.01),
          maxValue: maxValue(999999.99)
        },
        nueva: {
          uuid: {
            required: requiredIf(function () {
              return this.dialogNewCom && this.gastoDeducible;
            })
          },
          folio: {
            required: requiredIf(function () {
              return this.dialogNewCom && this.gastoDeducible;
            })
          },
          proveedor: {
            required: requiredIf(function () {
              return this.dialogNewCom && this.gastoDeducible;
            })
          },
          detalleNoDeducible: {
            required: requiredIf(function () {
              return this.dialogNewCom && !this.gastoDeducible;
            })
          },
          tipo_gasto: {
            required: requiredIf(function () {
              return this.dialogNewCom;
            })
          },
          concepto: {
            required: requiredIf(function () {
              return this.dialogNewCom;
            })
          },
          rfc: {
            required: requiredIf(function () {
              return this.dialogNewCom && this.gastoDeducible
            }),
            maxLength: maxLength(13)
          },
          subtotal: {
            required: requiredIf(function () {
              return this.dialogNewCom && this.gastoDeducible;
            }),
            decimal,
            minValue: minValue(0.01),
            maxValue: maxValue(999999.99)
          },
          descuento: {
            required: requiredIf(function () {
              return this.dialogNewCom && this.gastoDeducible;
            }),
            decimal,
            minValue: minValue(0),
            maxValue: maxValue(999999.99)
          },
          iva: {
            required: requiredIf(function () {
              return this.dialogNewCom && this.gastoDeducible;
            }),
            decimal,
            minValue: minValue(0),
            maxValue: maxValue(999999.99)
          },
          total: {
            required: requiredIf(function () {
              return this.dialogNewCom;
            }),
            decimal,
            minValue: minValue(0.01),
            maxValue: maxValue(999999.99)
          }
        }
      }
    }
  },
  data() {
    return {
      detailSolCom: false,
      questionSendComprobacion: false,
      idSolCom: null,
      firmas: null,
      dialogConfirmDelete: false,
      comprobanteSeleccionado: null,
      comprobanteAEliminar: null,
      estatusSolicitud: true,
      dialogComprobantes: false,
      dialogNewCom: false,
      dialogNewComprobacion: false,
      idsolicitud_amex: null,
      detalleSolicitudAmex: null,
      tipos_pago: ['Transferencia', 'Cheque'],
      tipo_gasto: {
        'deducible': 'Deducible',
        'no_deducible': 'No Deducible'
      },
      estados_cuenta: [],
      estado_cuenta_seleccionado: [],
      error: false,
      solicitud: {
        tipo_solicitud: 'Comprobación AMEX',
        tipo_pago: null,
        comprobantes: {
          importe_total: 0,
          no_comprobantes: 0,
          descuento: 0,
          subtotal: 0,
          iva: 0,
          nueva: {
            tipo_gasto: "deducible",
            pdf: { nombre: "", data: null },
            xml: { nombre: "", data: null },
            foto: { nombre: "", data: null },
            centro: null,
            concepto: "",
            rfc: "",
            proveedor: "",
            folio: "",
            uuid: "",
            no_comprobante: "",
            fecha_timbrado: "",
            subtotal: "",
            descuento: "",
            iva: "",
            total: "",
            totalIEPS: ""
          },
          detalle: []
        }
      },
      color: {
        pdf: "",
        xml: "",
        foto: ""
      },
      dialogDetalleAmex: false,
      headersDetalleEdc: [
        { text: 'Fecha Corte', value: 'fecha_corte', sortable: false },
        { text: 'Fecha Pago', value: 'fecha_pago', sortable: false },
        { text: 'Periodo', value: 'periodo', sortable: false },
        { text: 'Tarjetahabiente', value: 'tarjetahabiente', sortable: false },
        { text: 'Asistente', value: 'asistente', sortable: false },
        { text: 'Saldo a Pagar', value: 'saldo_a_pagar', sortable: false }
      ],
      headersEdc: [
        { text: 'Fecha Corte', value: 'fecha_corte' },
        { text: 'Fecha Pago', value: 'fecha_pago' },
        { text: 'Periodo', value: 'periodo' },
        { text: 'Tarjetahabiente', value: 'tarjetahabiente' },
        { text: 'Asistente', value: 'asistente' },
        { text: 'Saldo a Pagar', value: 'saldo_a_pagar' }
      ],
      headersComprobantes: [
        { text: 'Tipo de Gasto', value: 'fecha_corte' },
        { text: 'Concepto', value: 'fecha_pago' },
        { text: 'Fecha de Timbrado', value: 'periodo' },
        { text: 'Subtotal', value: 'tarjetahabiente' },
        { text: 'IVA', value: 'asistente' },
        { text: 'Descuento', value: 'asistente' },
        { text: 'Total', value: 'saldo_a_pagar' },
        { text: 'UUID', value: 'saldo_a_pagar' },
        { text: 'Acciones', value: 'saldo_a_pagar', sortable: false }
      ],
      questionReq: false,
      confirmCloseReq: false,
      msgError: "",
      msgSuccess: "",
      success: false,
      loading: false,
      alert: false,
      search: "",
      solicitudes: [],
      estados_cuenta: [],
      dialogDetCom: false,
      headers: [
        { text: "ID", value: "idsolicitud_comprobacion_amex", sortable: true, class: "text-xs-center" },
        { text: "Tipo Solicitud", value: "tipo_solicitud", sortable: true, class: "text-xs-center" },
        { text: "Tipo De Pago", value: "tipo_pago", sortable: true, class: "text-xs-center" },
        { text: "Importe Total", value: "importe_total", sortable: true, class: "text-xs-center" },
        { text: "Estatus", value: "idcat_estatus.estatus.nombre", sortable: true, class: "text-xs-center" },
        { text: "Fecha de Creación", value: "fecha_creacion ", sortable: true, class: "text-xs-center" },
        {
          text: "Acciones",
          value: "acciones",
          sortable: false,
          class: "text-xs-center"
        }
      ],
      headersEC: [
        {
          text: "Tarjetahabiente",
          value: "tarjetahabiente",
          sortable: false,
          class: "text-xs-center"
        },
        {
          text: "Fecha Corte",
          value: "fecha_corte",
          sortable: false,
          class: "text-xs-center"
        },
        {
          text: "Fecha Pago",
          value: "fecha_pago",
          sortable: false,
          class: "text-xs-center"
        },
        {
          text: "Saldo a pagar",
          value: "saldo_a_pagar",
          sortable: false,
          class: "text-xs-center"
        },
      ],
      catalogos: {
        centros: [],
        conceptos: [],
        detallesNoDeducibles: []
      },
      pagination: {
        rowsPerPage: 7
      },
    };
  },
  computed: {
    revisarAgregarBtn() {
      if (this.detailSolCom) {
        return this.estatusSolicitud
      }
      return (this.solicitud.estado_cuenta != null && this.solicitud.tipo_pago != null)
    },
    comprobanteInvalidoPorTotales() {
      if (!this.gastoDeducible) {
        return false
      }
      const { subtotal, iva, descuento, total } = this.solicitud.comprobantes.nueva;
      const st = parseFloat(subtotal) || 0;
      const iv = parseFloat(iva) || 0;
      const desc = parseFloat(descuento) || 0;
      const tot = parseFloat(total) || 0;
      return (st + iv - desc).toFixed(2) !== tot.toFixed(2);
    },
    proveedorErrors() {
      const errors = [];
      if (!this.$v.solicitud.comprobantes.nueva.proveedor.$dirty) return errors;
      !this.$v.solicitud.comprobantes.nueva.proveedor.required &&
        errors.push("El campo es obligatorio");
      return errors;
    },
    folioErrors() {
      const errors = [];
      if (!this.$v.solicitud.comprobantes.nueva.folio.$dirty) return errors;
      !this.$v.solicitud.comprobantes.nueva.folio.required &&
        errors.push("El campo es obligatorio");
      return errors;
    },
    uuidErrors() {
      const errors = [];
      if (!this.$v.solicitud.comprobantes.nueva.uuid.$dirty) return errors;
      !this.$v.solicitud.comprobantes.nueva.uuid.required &&
        errors.push("El campo es obligatorio");
      return errors;
    },
    detalleNoDeducibleErrors() {
      const errors = [];
      if (!this.$v.solicitud.comprobantes.nueva.detalleNoDeducible.$dirty) return errors;
      !this.$v.solicitud.comprobantes.nueva.detalleNoDeducible.required &&
        errors.push("El campo es obligatorio");
      return errors;
    },
    importeTotalErrors() {
      const errors = [];
      if (!this.$v.solicitud.comprobantes.importe_total.$dirty) return errors;
      !this.$v.solicitud.comprobantes.importe_total.decimal &&
        errors.push("El campo es inválido");
      !this.$v.solicitud.comprobantes.importe_total.minValue &&
        errors.push("El campo no alcanza el valor mínimo");
      !this.$v.solicitud.comprobantes.importe_total.maxValue &&
        errors.push("El campo excede el valor máximo");
      !this.$v.solicitud.comprobantes.importe_total.required &&
        errors.push("El campo es obligatorio");
      return errors;
    },
    tipoGastoErrors() {
      const errors = [];
      if (!this.$v.solicitud.comprobantes.nueva.tipo_gasto.$dirty) return errors;
      !this.$v.solicitud.comprobantes.nueva.tipo_gasto.required &&
        errors.push("El campo es obligatorio");
      return errors;
    },
    conceptoErrors() {
      const errors = [];
      if (!this.$v.solicitud.comprobantes.nueva.concepto.$dirty) return errors;
      !this.$v.solicitud.comprobantes.nueva.concepto.required &&
        errors.push("El campo es obligatorio");
      return errors;
    },
    rfcErrors() {
      const errors = [];
      if (!this.$v.solicitud.comprobantes.nueva.rfc.$dirty) return errors;
      !this.$v.solicitud.comprobantes.nueva.rfc.maxLength &&
        errors.push("El campo excede la longitud máxima");
      !this.$v.solicitud.comprobantes.nueva.rfc.required &&
        errors.push("El campo es obligatorio");
      return errors;
    },
    totalErrors() {
      const errors = [];
      if (!this.$v.solicitud.comprobantes.nueva.total.$dirty) return errors;
      !this.$v.solicitud.comprobantes.nueva.total.decimal &&
        errors.push("El campo es inválido");
      !this.$v.solicitud.comprobantes.nueva.total.minValue &&
        errors.push("El campo no alcanza el valor mínimo");
      !this.$v.solicitud.comprobantes.nueva.total.maxValue &&
        errors.push("El campo excede el valor máximo");
      !this.$v.solicitud.comprobantes.nueva.total.required &&
        errors.push("El campo es obligatorio");
      return errors;
    },
    descuentoErrors() {
      const errors = [];
      if (!this.$v.solicitud.comprobantes.nueva.descuento.$dirty) return errors;
      !this.$v.solicitud.comprobantes.nueva.descuento.decimal &&
        errors.push("El campo es inválido");
      !this.$v.solicitud.comprobantes.nueva.descuento.minValue &&
        errors.push("El campo no alcanza el valor mínimo");
      !this.$v.solicitud.comprobantes.nueva.descuento.maxValue &&
        errors.push("El campo excede el valor máximo");
      !this.$v.solicitud.comprobantes.nueva.descuento.required &&
        errors.push("El campo es obligatorio");
      return errors;
    },
    ivaErrors() {
      const errors = [];
      if (!this.$v.solicitud.comprobantes.nueva.iva.$dirty) return errors;
      !this.$v.solicitud.comprobantes.nueva.iva.decimal &&
        errors.push("El campo es inválido");
      !this.$v.solicitud.comprobantes.nueva.iva.minValue &&
        errors.push("El campo no alcanza el valor mínimo");
      !this.$v.solicitud.comprobantes.nueva.iva.maxValue &&
        errors.push("El campo excede el valor máximo");
      !this.$v.solicitud.comprobantes.nueva.iva.required &&
        errors.push("El campo es obligatorio");
      return errors;
    },
    totalErrors() {
      const errors = [];
      if (!this.$v.solicitud.comprobantes.nueva.total.$dirty) return errors;
      !this.$v.solicitud.comprobantes.nueva.total.decimal &&
        errors.push("El campo es inválido");
      !this.$v.solicitud.comprobantes.nueva.total.minValue &&
        errors.push("El campo no alcanza el valor mínimo");
      !this.$v.solicitud.comprobantes.nueva.total.maxValue &&
        errors.push("El campo excede el valor máximo");
      !this.$v.solicitud.comprobantes.nueva.total.required &&
        errors.push("El campo es obligatorio");
      return errors;
    },
    estadosCuentaErrors() {
      const errors = [];
      if (!this.$v.solicitud.estado_cuenta.$dirty) return errors;
      !this.$v.solicitud.estado_cuenta.required &&
        errors.push("El campo es obligatorio");
      return errors;
    },
    tiposPagoErrors() {
      const errors = [];
      if (!this.$v.solicitud.estado_cuenta.$dirty) return errors;
      !this.$v.solicitud.estado_cuenta.required &&
        errors.push("El campo es obligatorio");
      return errors;
    },
    isNewFac() {
      return this.dialogNewCom;
    },
    gastoDeducible() {
      return (
        this.dialogNewCom &&
        this.solicitud.comprobantes.nueva.tipo_gasto === "deducible"
      );
    },
    gastoNoDeducible() {
      return (
        this.dialogNewCom &&
        this.solicitud.comprobantes.nueva.tipo_gasto === "no_deducible"
      );
    },
  },
  async mounted() {
    this.$emit("update-title", "Solicitudes de comprobación AMEX");
    this.idsolicitud_amex = this.$route.params.idsolicitud_amex;
    await this.fetchSolicitudes();
    this.ws("get", "detalleUsuario")
      .then(res => {
        if (res.ok) {
          this.prepareForm(res.data);
        } else {
          this.error = true;
          this.msgError = res.message;
        }
      })
      .finally(() => {
        this.loading = false;
      });
    this.ws("post", "obtenerCatalogo", { tableName: 'cat_detalles_nodeducibles' })
      .then(res => {
        if (res.ok) {
          this.catalogos.detallesNoDeducibles = res.data.datos
        } else {
          this.error = true;
          this.msgError = res.message;
        }
      })
      .finally(() => {
        this.loading = false;
      });
  },
  watch: {
    'solicitud.estado_cuenta'(val) {
      if (this.detailSolCom)
        return
      if (val) {
        this.estado_cuenta_seleccionado = this.estados_cuenta.filter(
          ec => ec.idestado_cuenta_amex === val
        );
      } else {
        this.estado_cuenta_seleccionado = [];
      }
    }
  },
  methods: {
    ws(method, name, data) {
      if (method === "get") {
        if (this.$session.exists()) {
          let jwt = this.$session.get("jwt");
          let headers = {
            Authorization: "Bearer " + jwt
          };
          let params = "";
          for (let k in data) {
            params += k + "=" + data[k] + "&";
          }
          params = params !== "" ? "?" + params : "";
          return axios
            .get(services.routes[name] + params, { headers })
            .then(response => {
              let res = response.data;
              if (res.correcto) {
                return { ok: true, data: res.data, message: res.mensaje };
              } else {
                return { ok: false, message: res.mensaje };
              }
            })
            .catch(error => {
              console.log(error);
              error.response.status === 403 && this.$router.push("/403");
              return {
                ok: false,
                message:
                  "El servicio no se encuentra disponible en estos momentos"
              };
            });
        } else {
          this.$router.push("/login");
        }
      } else {
        if (this.$session.exists()) {
          let jwt = this.$session.get("jwt");
          let headers = {
            Authorization: "Bearer " + jwt
          };
          return axios
            .post(services.routes[name], data, { headers })
            .then(response => {
              let res = response.data;
              if (res.correcto) {
                return { ok: true, data: res.data, message: res.mensaje };
              } else {
                return { ok: false, message: res.mensaje };
              }
            })
            .catch(error => {
              console.log(error);
              error.response.status === 403 && this.$router.push("/403");
              return {
                ok: false,
                message:
                  "El servicio no se encuentra disponible en estos momentos"
              };
            });
        } else {
          this.$router.push("/login");
        }
      }
    },
    formatMoney(v) {
      if (v === null || v === undefined || v === '') return '';
      const n = Number(v);
      return Number.isFinite(n) ? n.toFixed(2) : '';
    },
    handleClose() {
      if (this.detailSolCom) {
        this.dialogNewComprobacion = false;
        this.refresh()
      } else {
        this.reset();
        this.confirmCloseReq = true;
      }
    },
    verDetalleComprobante(comprobante) {
      this.dialogDetCom = true;
      this.comprobanteSeleccionado = comprobante.data;
    },
    async descargarArchivo(archivo, tipo) {
      if (typeof archivo.data === 'number') {
        try {
          const jwt = this.$session.get("jwt");
          const headers = {
            Authorization: "Bearer " + jwt
          };

          const params = new URLSearchParams();
          params.append("idcomprobante_amex", archivo.data);
          params.append("tipo", tipo);

          const response = await axios.get(
            `${services.routes.amexComprobanteDescarga}?${params.toString()}`,
            {
              headers,
              responseType: "blob"
            }
          );

          const disposition = response.headers["content-disposition"];
          if (!disposition
          ) {
            this.msgError = "Archivo no Disponible";
            this.alert = true;
            return
          }
          let filename = "archivo";
          if (disposition && disposition.includes("filename=")) {
            filename = disposition.split("filename=")[1].replace(/["']/g, "");
          }
          const blob = new Blob([response.data], { type: response.headers["content-type"] });
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = filename;
          link.click();
          URL.revokeObjectURL(link.href);
        } catch (err) {
          console.error("Error al descargar comprobante:", err);
          this.alert = true;
          if (err && err.response && err.response.data && err.response.data.message) {
            this.msgError = err.response.data.message;
          } else if (err && err.message) {
            this.msgError = err.message;
          } else {
            this.msgError = "Error al descargar el comprobante";
          }
        }
        return
      }

      if (!archivo || !archivo.data) return;
      const link = document.createElement('a');
      link.href = URL.createObjectURL(archivo.data);
      link.download = archivo.nombre || 'archivo';
      link.click();
      URL.revokeObjectURL(link.href);
    },
    eliminarComprobante(comprobante) {
      this.comprobanteAEliminar = comprobante;
      this.dialogConfirmDelete = true;

    },
    async confirmarEliminacion() {
      if (this.detailSolCom) {
        try {
          this.loading = true;
          const jwt = this.$session.get("jwt");
          const headers = { Authorization: "Bearer " + jwt };
          let data = {
            idcomprobante_amex: Number(this.comprobanteAEliminar.id),
          }
          let res = await axios.post(services.routes.amexComprobanteDelete, data, {
            headers
          });
          this.success = true;
          this.msgSuccess = "Comprobante borrado correctamente.";
        } catch (err) {
          this.loading = false;
          this.alert = true;
          if (err && err.response && err.response.data) {
            this.msgError = err.response.data.message || "Error del servidor";
          } else {
            this.msgError = err.message || "Error desconocido";
          }
        } finally {
          this.loading = false;
        }
      }
      const index = this.solicitud.comprobantes.detalle.indexOf(this.comprobanteAEliminar);
      if (index !== -1) {
        this.solicitud.comprobantes.detalle.splice(index, 1);
        this.solicitud.comprobantes.no_comprobantes = this.solicitud.comprobantes.detalle.length;
      }
      this.comprobanteAEliminar = null
      this.dialogConfirmDelete = false;
      this.calcularTotales()
    },
    showDetailCom() {
      this.dialogComprobantes = true;
    },
    getConceptoDesc(id) {
      if (isNaN(id)) return id
      const concepto = this.catalogos.conceptos.find(c => c.id === id);
      return concepto ? concepto.descripcion : 'No encontrado';
    },
    prepareForm(data) {
      this.catalogos.centros = data.catalogos.centros;
      this.catalogos.conceptos = data.catalogos.conceptos;
      this.catalogos.conceptos_sat = data.catalogos.conceptos_sat;
      this.catalogos.cajas_chicas = data.catalogos.cajas_chicas;
    },
    resetCamposNuevoComprobante() {
      this.$v.solicitud.comprobantes.nueva.$reset();
      let tipoGastos = this.solicitud.comprobantes.nueva.tipo_gasto;
      this.solicitud.comprobantes.nueva = {
        ...this.solicitud.comprobantes.nueva,
        tipo_gasto: tipoGastos,
        concepto: "",
        detalleNoDeducible: null,
        rfc: "",
        proveedor: "",
        folio: "",
        uuid: "",
        subtotal: "",
        descuento: "",
        iva: "",
        total: ""
      };
      this.$refs.pdf.value = "";
      this.$refs.xml.value = "";
      this.$refs.foto.value = "";
      this.color.pdf = "";
      this.color.xml = "";
      this.color.foto = "";

      if (tipoGastos == 'no_deducible') {
        for (let i = 0; i < this.catalogos.conceptos.length; i++) {
          if (
            this.catalogos.conceptos[i].cuenta == "12204" &&
            this.catalogos.conceptos[i].subcuenta == "000000"
          ) {
            this.solicitud.comprobantes.nueva.concepto = this.catalogos.conceptos[
              i
            ].id;
          }
        }
      }

    },
    closeNewCom() {
      this.$v.$reset();
      this.color = {
        pdf: "",
        xml: "",
        foto: ""
      };
      this.solicitud.comprobantes.nueva = {
        tipo_gasto: "deducible",
        pdf: { nombre: "", data: null },
        xml: { nombre: "", data: null },
        foto: { nombre: "", data: null },
        centro: null,
        concepto: "",
        no_factura: "",
        fecha_timbrado: "",
        subtotal: "",
        descuento: "",
        iva: "",
        total: ""
      };
      this.$refs.pdf.value = "";
      this.$refs.xml.value = "";
      this.$refs.foto.value = "";
      this.dialogNewCom = false;
    },
    refresh() {
      this.fetchSolicitudes();
    },

    async saveComprobantes(idsolicitud_comprobacion_amex) {
      try {
        const jwt = this.$session.get("jwt");
        const headers = {
          Authorization: `Bearer ${jwt}`,
        };

        for (let c of this.solicitud.comprobantes.detalle) {
          const formData = new FormData();

          formData.append("tipo_gasto", c.tipo_gasto);
          formData.append("idcat_concepto", c.concepto);
          formData.append("idcat_detalle_nodeducible", c.detalleNoDeducible || '');
          formData.append("idcat_centro_costo", this.detalleSolicitudAmex.centro_costo.id);
          formData.append("idsolicitud_comprobacion_amex", idsolicitud_comprobacion_amex);
          formData.append("idestado_cuenta_amex", this.solicitud.estado_cuenta);
          formData.append("proveedor", c.proveedor);
          formData.append("subtotal", c.subtotal);
          formData.append("iva", c.iva);
          formData.append("descuento", c.descuento);
          formData.append("total", c.total);
          formData.append("pdf", c.pdf.data);
          formData.append("foto", c.foto.data);

          if (c.tipo_gasto !== 'no_deducible') {
            formData.append("xml", c.xml.data);
          }
          await axios.post(services.routes.amexComprobanteUpload, formData, { headers });
        }

      } catch (err) {
        console.error("Error al guardar comprobante:", err);
        this.alert = true;

        if (
          err &&
          err.response &&
          err.response.data &&
          err.response.data.message
        ) {
          this.msgError = err.response.data.message;
        } else if (err && err.message) {
          this.msgError = err.message;
        } else {
          this.msgError = "Error al guardar el comprobante";
        }
      } finally {
        this.loading = false;
      }
    },
    async sendSol() {
      this.questionSendComprobacion = false;
      this.loading = true;
      try {
        const jwt = this.$session.get("jwt");
        const headers = { Authorization: "Bearer " + jwt };
        this.solicitud.idsolicitud_amex = this.idsolicitud_amex
        let data = {
          idsolicitud_comprobacion_amex: Number(this.idSolCom),
        }
        let res = await axios.post(services.routes.amexComprobacionEnviar, data, {
          headers
        });
        this.confirmClose()
        this.refresh();
        this.success = true;
        this.msgSuccess = "Solicitud de comprobación enviada correctamente.";
      } catch (err) {
        this.loading = false;
        this.alert = true;
        if (err && err.response && err.response.data) {
          this.msgError = err.response.data.message || "Error del servidor";
        } else {
          this.msgError = err.message || "Error desconocido";
        }
      } finally {
        this.loading = false;
      }
    },
    async saveSol() {
      this.questionReq = false;
      this.loading = true;
      try {
        const jwt = this.$session.get("jwt");
        const headers = { Authorization: "Bearer " + jwt };
        this.solicitud.idsolicitud_amex = this.idsolicitud_amex
        let data = {
          idsolicitud_amex: Number(this.solicitud.idsolicitud_amex),
          idestado_cuenta_amex: this.solicitud.estado_cuenta,
          tipo_pago: this.solicitud.tipo_pago,
          tipo_solicitud: this.solicitud.tipo_solicitud
        }
        let res = await axios.post(services.routes.amexSolcitudComprobacion, data, {
          headers
        });
        let idsolicitud_comprobacion_amex = res.data.idsolicitud_comprobacion_amex
        await this.saveComprobantes(idsolicitud_comprobacion_amex)
        this.confirmClose()
        this.refresh();
        this.success = true;
        this.msgSuccess = "Solicitud de comprobación creada correctamente.";
      } catch (err) {
        this.loading = false;
        this.alert = true;
        if (err && err.response && err.response.data) {
          this.msgError = err.response.data.message || "Error del servidor";
        } else {
          this.msgError = err.message || "Error desconocido";
        }
      } finally {
        this.loading = false;
      }
    },
    reset() {
      this.detailSolCom = false
      this.solicitud = {
        tipo_solicitud: 'Comprobación AMEX',
        estado_cuenta: null,
        tipo_pago: null,
        tipoSolicitud: null,
        tipoPago: null,
        empresa: "",
        unidad: "",
        plaza: "",
        centro: "",
        beneficiario: "",
        comprobantes: {
          importe_total: 0,
          no_comprobantes: 0,
          descuento: 0,
          subtotal: 0,
          iva: 0,
          nueva: {
            tipo_gasto: "deducible",
            pdf: { nombre: "", data: null },
            xml: { nombre: "", data: null },
            foto: { nombre: "", data: null },
            centro: null,
            concepto: "",
            rfc: "",
            proveedor: "",
            folio: "",
            uuid: "",
            no_comprobante: "",
            fecha_timbrado: "",
            subtotal: "",
            descuento: "",
            iva: "",
            total: ""
          },
          detalle: []
        }
      },
        this.$v.$reset();
    },
    async descargarTodo() {
      this.loading = true;
      try {
        const jwt = this.$session.get("jwt");
        const headers = { Authorization: "Bearer " + jwt };
        const url = services.routes.descargarComprobantesComprobacionAMEX.replace(
          ":idsolicitud",
          this.idSolCom
        );

        const response = await axios.get(url, { headers, responseType: "blob" });

        const blob = new Blob([response.data]);
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `Comprobantes-Comprobacion-AMEX-${this.idSolCom}.zip`;
        link.click();
        window.URL.revokeObjectURL(link.href);

      } catch (err) {
        this.alert = true;
        if (err && err.response && err.response.data) {
          this.msgError = err.response.data.message || "Error del servidor";
        } else {
          this.msgError = err.message || "Error desconocido";
        }
        console.error("Error al descargar comprobantes:", err);
      } finally {
        this.loading = false;
      }
    },
    checkQuestionReq() {
      this.questionReq = false;
      if (this.solicitud.comprobantes.detalle.length == 0) {
        this.error = true;
        this.msgError = "Debe subir al menos 1 comprobante";
        return false
      }
      if (this.estados_cuenta.length == 0) {
        this.alert = true;
        this.msgError = "Debe seleccionar 1 estado de cuenta.";
        return;
      }
      this.questionReq = true;
    },
    checkSendComprobacion() {
      this.questionSendComprobacion = true;
    },
    confirmClose() {
      this.reset();
      this.refresh()
      this.dialogNewComprobacion = false;
      this.confirmCloseReq = false;
    },
    formatCurrency(val) {
      return new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(val || 0);
    },
    formatDateShort(date) {
      if (!date) return '';
      const d = new Date(date.toLocaleString('en-US', { timeZone: 'America/Mexico_City' }));
      const pad = (n) => n.toString().padStart(2, '0');
      return `${pad(d.getDate())}-${pad(d.getMonth() + 1)}-${pad(d.getFullYear())} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
    },
    print() {
      this.loading = true;
      let data = {
        idsolicitud_comprobacion_amex: this.idSolCom,
        idsolicitud_amex: this.idsolicitud_amex
      };
      this.ws("get", "impresionDetalleSolicitudComprobacionAMEX", data)
        .then(res => {
          if (res.ok) {
            this.handleClose();
            this.refresh();
            this.success = true;
            this.msgSuccess = res.message;
            window.open(res.data, "_blank");
          } else {
            this.error = true;
            this.msgError = res.message;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    async showDetailSol(id) {
      try {
        this.detailSolCom = true
        this.estatusSolicitud = true
        this.idSolCom = id
        const estadosCuenta = this.detalleSolicitudAmex.estados_cuenta;
        const solicitudesComprobacion = this.detalleSolicitudAmex.solicitudes_comprobacion_amex;
        const solicitud = solicitudesComprobacion.find(sc => sc.idsolicitud_comprobacion_amex === id);
        let estadoCuentaAsociado = null;
        if (solicitud) {
          this.firmas = solicitud.firmas
          estadoCuentaAsociado = estadosCuenta.find(ec => ec.idestado_cuenta_amex === solicitud.idestado_cuenta_amex);
        }
        this.estados_cuenta = [estadoCuentaAsociado]
        this.solicitud.estado_cuenta = estadoCuentaAsociado
        this.estado_cuenta_seleccionado = [estadoCuentaAsociado]
        this.solicitud.tipo_pago = solicitud.tipo_pago
        this.loading = true;
        this.dialogNewComprobacion = true
        if (solicitud.idcat_estatus.idcat_estatus != 1) {
          this.estatusSolicitud = false
        }
        this.solicitud.comprobantes.detalle = []
        for (let c of solicitud.comprobantes_amex) {
          this.solicitud.comprobantes.detalle.push({
            id: c.idcomprobante_amex,
            tipo_gasto: c.tipo_gasto,
            concepto: c.idcat_concepto.subcuenta + " - " + c.idcat_concepto.descripcion,
            fecha_timbrado: c.fecha_timbrado,
            subtotal: c.subtotal,
            iva: c.iva,
            descuento: c.descuento,
            total: c.total,
            uuid: c.uuid,
            xml: { data: c.idcomprobante_amex },
            pdf: { data: c.idcomprobante_amex },
            foto: { data: c.idcomprobante_amex },
            data: c,
          })
        }
        this.solicitud.comprobantes.no_comprobantes = solicitud.comprobantes_amex.length;
        this.calcularTotales()
      } catch (err) {

      } finally {
        this.loading = false;
      }
    },
    async fetchSolicitudes() {
      this.loading = true;
      try {
        const jwt = this.$session.get("jwt");
        const headers = { Authorization: "Bearer " + jwt };
        const url = services.routes.amexSolicitudesDetalle.replace(
          ":idsolicitud_amex",
          this.idsolicitud_amex
        );
        const { data } = await axios.get(url, { headers });
        this.detalleSolicitudAmex = data
        const estadosCuenta = data.estados_cuenta;
        const solicitudesComprobacion = data.solicitudes_comprobacion_amex;

        //Activo,En Aprobacion, Aprobado
        const estatusExcluidos = [1, 4, 5];
        let estadosCuentaFiltrados = estadosCuenta.filter(ec => {
          const solicitud = solicitudesComprobacion.find(
            sc => sc.idestado_cuenta_amex === ec.idestado_cuenta_amex
          );
          if (!solicitud) return true;
          if (
            solicitud.idcat_estatus &&
            typeof solicitud.idcat_estatus.idcat_estatus === 'number'
          ) {
            return estatusExcluidos.indexOf(solicitud.idcat_estatus.idcat_estatus) === -1;
          }
        });

        const userid = this.$session.get("userid");
        estadosCuentaFiltrados = estadosCuentaFiltrados.filter(
          ec => ec.idusuario_asistente == userid
        );

        this.estados_cuenta = estadosCuentaFiltrados
        this.solicitudes = data.solicitudes_comprobacion_amex
      } catch (err) {
        console.error("Error al cargar detalle:", err);
      } finally {

        this.loading = false;
      }
    },
    calcularTotales() {
      let subtotal = 0.0
      let descuento = 0.0
      let iva = 0.0
      let total = 0.0
      for (let i = 0; i < this.solicitud.comprobantes.detalle.length; i++) {
        subtotal += parseFloat(
          parseFloat(this.solicitud.comprobantes.detalle[i].subtotal).toFixed(
            2
          )
        );
        descuento += parseFloat(
          parseFloat(
            this.solicitud.comprobantes.detalle[i].descuento
          ).toFixed(2)
        );
        iva += parseFloat(
          parseFloat(this.solicitud.comprobantes.detalle[i].iva).toFixed(2)
        );
        total += parseFloat(
          parseFloat(this.solicitud.comprobantes.detalle[i].total).toFixed(2)
        );
      }

      this.solicitud.comprobantes.subtotal = subtotal.toFixed(2);
      this.solicitud.comprobantes.iva = iva.toFixed(2);
      this.solicitud.comprobantes.descuento = descuento.toFixed(2);
      this.solicitud.comprobantes.importe_total = total.toFixed(2);
    },
    updateModalComprobacion() {
      this.solicitud.comprobantes.detalle.push({
        tipo_gasto: this.tipo_gasto[this.solicitud.comprobantes.nueva.tipo_gasto],
        concepto: this.solicitud.comprobantes.nueva.concepto,
        fecha_timbrado: this.solicitud.comprobantes.nueva.fecha_timbrado,
        subtotal: this.solicitud.comprobantes.nueva.subtotal || 0,
        iva: this.solicitud.comprobantes.nueva.iva || 0,
        descuento: this.solicitud.comprobantes.nueva.descuento || 0,
        total: this.solicitud.comprobantes.nueva.total,
        uuid: this.solicitud.comprobantes.nueva.uuid,
        xml: this.solicitud.comprobantes.nueva.xml,
        pdf: this.solicitud.comprobantes.nueva.pdf,
        foto: this.solicitud.comprobantes.nueva.foto,
        detalleNoDeducible: this.solicitud.comprobantes.nueva.detalleNoDeducible,
        proveedor: this.solicitud.comprobantes.nueva.proveedor
      })
      this.solicitud.comprobantes.no_comprobantes = this.solicitud.comprobantes.detalle.length;

      this.calcularTotales()
      this.closeNewCom()
    },
    async saveNewCom() {
      this.loading = true
      this.$v.solicitud.comprobantes.nueva.$touch();
      if (this.$v.solicitud.comprobantes.nueva.$invalid) {
        this.loading = false
        return
      }

      // Usar los datos ya cargados en readFile() en lugar de intentar leer files nuevamente
      let pdf_data = this.solicitud.comprobantes.nueva.pdf.data;
      let xml_data = this.solicitud.comprobantes.nueva.xml.data;
      let foto_data = this.solicitud.comprobantes.nueva.foto.data;

      // Validación según tipo de gasto
      if (this.solicitud.comprobantes.nueva.tipo_gasto == 'deducible') {
        // Para deducible: PDF y XML son obligatorios
        if (!pdf_data) {
          this.error = true;
          this.msgError = "Archivo PDF es requerido para gasto deducible";
          this.loading = false
          return false
        }
        if (!xml_data) {
          this.error = true;
          this.msgError = "Archivo XML es requerido para gasto deducible";
          this.loading = false
          return false
        }
      } else {
        // Para no deducible: Al menos PDF o FOTO es obligatorio
        if (!pdf_data && !foto_data) {
          this.error = true;
          this.msgError = "Debe cargar al menos PDF o FOTO para gasto no deducible";
          this.loading = false
          return false
        }
      }

      //Flujo desde Detalle Comprobacion
      if (this.detailSolCom) {
        try {
          const formData = new FormData();
          formData.append("tipo_gasto", this.tipo_gasto[this.solicitud.comprobantes.nueva.tipo_gasto]);
          formData.append("idcat_concepto", this.solicitud.comprobantes.nueva.concepto);
          formData.append("idcat_detalle_nodeducible", this.solicitud.comprobantes.nueva.detalleNoDeducible || '');
          formData.append("idcat_centro_costo", this.detalleSolicitudAmex.centro_costo.id);
          formData.append("idsolicitud_comprobacion_amex", this.idSolCom);
          formData.append("idestado_cuenta_amex", this.solicitud.estado_cuenta.idestado_cuenta_amex);
          formData.append("proveedor", this.solicitud.comprobantes.nueva.proveedor);
          formData.append("subtotal", this.solicitud.comprobantes.nueva.subtotal);
          formData.append("iva", this.solicitud.comprobantes.nueva.iva);
          formData.append("descuento", this.solicitud.comprobantes.nueva.descuento);
          formData.append("total", this.solicitud.comprobantes.nueva.total);
          formData.append("pdf", this.solicitud.comprobantes.nueva.pdf.data);
          formData.append("foto", this.solicitud.comprobantes.nueva.foto.data);

          if (this.solicitud.comprobantes.nueva.tipo_gasto === 'deducible' && xml_data) {
            formData.append("xml", xml_data);
          }
          const jwt = this.$session.get("jwt");
          const headers = {
            Authorization: `Bearer ${jwt}`,
          };

          const response = await axios.post(services.routes.amexComprobanteUpload, formData, { headers });
          this.success = true;
          this.msgSuccess = "Comprobante guardado correctamente";
          this.updateModalComprobacion()
          this.loading = false
          return
        } catch (err) {
          console.error(" Error al guardar comprobante:", err);
          this.alert = true;
          this.loading = false
          if (err && err.response && err.response.data && err.response.data.message) {
            this.msgError = err.response.data.message;
          } else if (err && err.message) {
            this.msgError = err.message;
          } else {
            this.msgError = "Error al guardar el comprobante";
          }
        }
      } else {
        //Flujo Nueva Comprobacion
        this.loading = false
        this.updateModalComprobacion()
      }

      console.log("Sol comprobante guardada:", this.solicitud.comprobantes.nueva)
    },
    async newSol() {
      this.reset()
      this.dialogNewComprobacion = true
    },
    async readFile(doc) {
      console.log("Leyendo archivo:", doc);
      this.alert = false;
      let file = this.$refs[doc].files;
      if (!file || !file[0]) return;
      const archivo = file[0];
      const nombreArchivo = archivo.name.toLowerCase();

      if (doc === "pdf" && !nombreArchivo.endsWith(".pdf")) {
        this.alert = true;
        this.msgError = "El archivo debe ser un PDF válido.";
        this.$refs[doc].value = null;
        this.color[doc] = "";
        return;
      }

      if (doc === "xml" && !nombreArchivo.endsWith(".xml")) {
        this.alert = true;
        this.msgError = "El archivo debe ser un XML válido.";
        this.$refs[doc].value = null;
        this.color[doc] = "";
        return;
      }

      if (doc === "foto" && !(/\.(jpg|jpeg|png|gif|bmp)$/i.test(nombreArchivo))) {
        this.alert = true;
        this.msgError = "El archivo debe ser una imagen válida (JPG, PNG, GIF, BMP).";
        this.$refs[doc].value = null;
        this.color[doc] = "";
        return;
      }

      const yaExiste = this.solicitud.comprobantes.detalle.some(comp => {
        if (doc === 'pdf' && comp.pdf && comp.pdf.nombre) {
          return comp.pdf.nombre.toLowerCase() === nombreArchivo;
        }
        if (doc === 'xml' && comp.xml && comp.xml.nombre) {
          return comp.xml.nombre.toLowerCase() === nombreArchivo;
        }
        return false;
      });
      if (yaExiste) {
        this.alert = true;
        this.msgError = `Ya existe un comprobante con el archivo ${doc.toUpperCase()} "${nombreArchivo}"`;
        this.$refs[doc].value = null;
        this.color[doc] = '';
        return;
      }


      let size = file[0].size;
      if (size <= 10000000) {
        // Almacenar el archivo como Blob para envío binario
        this.color[doc] = "success";
        this.solicitud.comprobantes.nueva[doc].nombre = file[0].name;
        this.solicitud.comprobantes.nueva[doc].data = file[0]; // Guardar el File/Blob original

        if (doc === "xml") {
          this.loading = true;
          const formData = new FormData();
          formData.append("xml", file[0]);
          const jwt = this.$session.get("jwt");
          axios
            .post(services.routes.amexProcesarXML, formData, {
              headers: {
                "Content-Type": "multipart/form-data",
                Authorization: `Bearer ${jwt}`
              }
            })
            .then(res => {
              let data = res.data;
              this.solicitud.comprobantes.nueva.rfc = data.rfc_emisor
              this.solicitud.comprobantes.nueva.proveedor = data.proveedor
              this.solicitud.comprobantes.nueva.folio = data.folio
              this.solicitud.comprobantes.nueva.uuid = data.uuid
              this.solicitud.comprobantes.nueva.subtotal = Number(data.subtotal) + Number(data.totalIEPS)
              this.solicitud.comprobantes.nueva.iva = data.iva
              this.solicitud.comprobantes.nueva.descuento = data.descuento
              this.solicitud.comprobantes.nueva.total = data.total
              this.solicitud.comprobantes.nueva.fecha_timbrado = data.fecha_timbrado
              this.solicitud.comprobantes.nueva.totalIEPS = data.totalIEPS
              let concepto = data.conceptos[0]
              let cve = concepto.clave_prod_serv
              let cuenta = "";
              let subcuenta = "";
              for (let i = 0; i < this.catalogos.conceptos_sat.length; i++) {
                if (this.catalogos.conceptos_sat[i].clave == cve) {
                  cuenta = this.catalogos.conceptos_sat[i].cuenta;
                  subcuenta = this.catalogos.conceptos_sat[i].subcuenta;
                  for (let j = 0; j < this.catalogos.conceptos.length; j++) {
                    if (
                      this.catalogos.conceptos[j].cuenta == cuenta &&
                      this.catalogos.conceptos[j].subcuenta == subcuenta
                    ) {
                      this.solicitud.comprobantes.nueva.concepto = this.catalogos.conceptos[
                        j
                      ].id;
                    }
                  }
                }
              }
              if (this.solicitud.comprobantes.nueva.concepto == '') {
                for (let i = 0; i < this.catalogos.conceptos.length; i++) {
                  if (
                    this.catalogos.conceptos[i].cuenta == "12204" &&
                    this.catalogos.conceptos[i].subcuenta == "000000"
                  ) {
                    this.solicitud.comprobantes.nueva.concepto = this.catalogos.conceptos[
                      i
                    ].id;
                  }
                }
              }
              this.loading = false;
            })
            .catch(err => {
              this.loading = false;
              this.alert = true;
              if (err && err.response && err.response.data) {
                this.msgError =
                  err.response.data.message || "Error del servidor";
              } else {
                this.msgError = err.message || "Error desconocido";
              }
              this.$refs[doc].value = null;
              this.color[doc] = '';
            });
        }
      } else {
        this.alert = true;
        this.msgError = "El archivo ha excedido el límite permitido (10 MB)";
        this.loading = false;
      }

    },
  }
};
</script>
